import React, { useEffect, createElement } from 'react';
import { Hero } from './components/Hero';
import { StatsBar } from './components/StatsBar';
import { FuncionaSection } from './components/FuncionaSection';
import { PainPoints } from './components/PainPoints';
import { Modules } from './components/Modules';
import { CTABreak } from './components/CTABreak';
import { Bonuses } from './components/Bonuses';
import { Testimonials } from './components/Testimonials';
import { UrgencyBar } from './components/UrgencyBar';
import { Pricing } from './components/Pricing';
import { Guarantee } from './components/Guarantee';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    // Meta Pixel
    !function (f: any, b: any, e: any, v: any, n?: any, t?: any, s?: any) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '951290054277690');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <div className="min-h-screen flex flex-col font-sans" data-id="element-0">
      <main className="flex-grow" data-id="element-1">
        <Hero data-id="element-2" />
        <StatsBar data-id="element-3" />
        <FuncionaSection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Modules data-id="element-6" />
        <CTABreak data-id="element-7" />
        <Bonuses data-id="element-8" />
        <Testimonials data-id="element-9" />
        <UrgencyBar data-id="element-10" />
        <Pricing data-id="element-11" />
        <Guarantee data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}